import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const RoleServices = {
  roleList: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.ROLES, { params }),
  permissionList: () => AxiosInstance.get(ContentApiRoutes.PERMISSIONS),
  rolePermissionsList: (roleName: String) =>
    AxiosInstance.get(ContentApiRoutes.ROLE_PERMISSIONS + roleName),
  assignRolePermissions: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.ASSIGN_ROLE_PERMISSIONS, params),
  replaceRolePermissions: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.REPLACE_ROLE_PERMISSIONS, params),

  fetchDownRoles: (value: string) =>
    AxiosInstance.get(
      ContentApiRoutes.DOWN_ROLES_BY_ROLE_TYPE.replace(
        ":roleType",
        value.toString()
      )
    ),

  setRoleTypeByUserType: (value: string) =>
    AxiosInstance.get(
      ContentApiRoutes.ROLES_BY_USER_TYPE.replace(":roleType", value.toString())
    ),
};
